import { put } from 'redux-saga/effects'
import _ from 'lodash'

import { manageGroupsDialogLoadingTrue, manageGroupsDialogLoadingFalse } from '../actions'

import { getIsPresentInGroups, reloadRows } from '../helpers'

export default function* dialogInitCallSaga(action) {
    yield put(manageGroupsDialogLoadingTrue())

    const entities = _.get(action, 'data.entities', [])

    // For single entity, get in which groups an entity is present
    let isPresentInGroups = []
    if (entities.length === 1) {
        const entId = _.get(entities, '[0].id', null)

        isPresentInGroups = yield getIsPresentInGroups(entId)
    }

    // Load rows (loads groups and sets data from groups to state)
    yield reloadRows(isPresentInGroups)

    yield put(manageGroupsDialogLoadingFalse())

    return null
}
